import{createContext as o,useContext as r}from"react";const t=o({}),c=()=>r(t);export{t as AccordionContext,c as useAccordionContext};
//# sourceMappingURL=AccordionContext.js.map
